export const ADMIN_OVERVIEW_REFRESH_EVENT = 'sugarloaf:overview-refresh';

export function refreshAdminOverview() {
  window.dispatchEvent(new Event(ADMIN_OVERVIEW_REFRESH_EVENT));
}
